"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.HeaderToggle = exports.HeaderRight = exports.HeaderNav = exports.HeaderList = exports.HeaderLink = exports.HeaderLeft = exports.HeaderItem = exports.HeaderInner = exports.HeaderHideOnMobile = exports.HeaderHideOnDesktop = exports.HeaderCenter = exports.HeaderButton = void 0;
require("core-js/modules/es6.string.link.js");
require("core-js/modules/es6.string.bold.js");
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
function cov_23f8484al5() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/HeaderStyles.js";
  var hash = "cb6538639df061ebc62a679664fc9f55de543bd4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/HeaderStyles.js",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 40
        }
      },
      "1": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 26,
          column: 1
        }
      },
      "2": {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      },
      "3": {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 20
        }
      },
      "4": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 54
        }
      },
      "5": {
        start: {
          line: 23,
          column: 27
        },
        end: {
          line: 23,
          column: 69
        }
      },
      "6": {
        start: {
          line: 25,
          column: 31
        },
        end: {
          line: 25,
          column: 84
        }
      },
      "7": {
        start: {
          line: 28,
          column: 20
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "8": {
        start: {
          line: 45,
          column: 19
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "9": {
        start: {
          line: 57,
          column: 21
        },
        end: {
          line: 61,
          column: 1
        }
      },
      "10": {
        start: {
          line: 63,
          column: 20
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "11": {
        start: {
          line: 75,
          column: 19
        },
        end: {
          line: 83,
          column: 1
        }
      },
      "12": {
        start: {
          line: 85,
          column: 21
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "13": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 100,
          column: 3
        }
      },
      "14": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 105,
          column: 3
        }
      },
      "15": {
        start: {
          line: 108,
          column: 19
        },
        end: {
          line: 129,
          column: 1
        }
      },
      "16": {
        start: {
          line: 117,
          column: 27
        },
        end: {
          line: 117,
          column: 59
        }
      },
      "17": {
        start: {
          line: 123,
          column: 20
        },
        end: {
          line: 123,
          column: 79
        }
      },
      "18": {
        start: {
          line: 127,
          column: 22
        },
        end: {
          line: 127,
          column: 91
        }
      },
      "19": {
        start: {
          line: 131,
          column: 18
        },
        end: {
          line: 137,
          column: 1
        }
      },
      "20": {
        start: {
          line: 139,
          column: 19
        },
        end: {
          line: 146,
          column: 1
        }
      },
      "21": {
        start: {
          line: 148,
          column: 21
        },
        end: {
          line: 154,
          column: 1
        }
      },
      "22": {
        start: {
          line: 156,
          column: 27
        },
        end: {
          line: 166,
          column: 1
        }
      },
      "23": {
        start: {
          line: 168,
          column: 28
        },
        end: {
          line: 175,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 16
          },
          end: {
            line: 16,
            column: 17
          }
        },
        loc: {
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 23,
            column: 18
          },
          end: {
            line: 23,
            column: 19
          }
        },
        loc: {
          start: {
            line: 23,
            column: 27
          },
          end: {
            line: 23,
            column: 69
          }
        },
        line: 23
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 22
          },
          end: {
            line: 25,
            column: 23
          }
        },
        loc: {
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 25,
            column: 84
          }
        },
        line: 25
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 90,
            column: 5
          }
        },
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 100,
            column: 3
          }
        },
        line: 91
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 101,
            column: 4
          },
          end: {
            line: 101,
            column: 5
          }
        },
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 105,
            column: 3
          }
        },
        line: 102
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 117,
            column: 17
          },
          end: {
            line: 117,
            column: 18
          }
        },
        loc: {
          start: {
            line: 117,
            column: 27
          },
          end: {
            line: 117,
            column: 59
          }
        },
        line: 117
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 123,
            column: 11
          },
          end: {
            line: 123,
            column: 12
          }
        },
        loc: {
          start: {
            line: 123,
            column: 20
          },
          end: {
            line: 123,
            column: 79
          }
        },
        line: 123
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 127,
            column: 13
          },
          end: {
            line: 127,
            column: 14
          }
        },
        loc: {
          start: {
            line: 127,
            column: 22
          },
          end: {
            line: 127,
            column: 91
          }
        },
        line: 127
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 47
          }
        }, {
          start: {
            line: 20,
            column: 51
          },
          end: {
            line: 20,
            column: 53
          }
        }],
        line: 20
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 27
          },
          end: {
            line: 23,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 27
          },
          end: {
            line: 23,
            column: 63
          }
        }, {
          start: {
            line: 23,
            column: 67
          },
          end: {
            line: 23,
            column: 69
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 25,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 25,
            column: 67
          }
        }, {
          start: {
            line: 25,
            column: 71
          },
          end: {
            line: 25,
            column: 84
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 100,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 91,
            column: 14
          }
        }, {
          start: {
            line: 92,
            column: 4
          },
          end: {
            line: 100,
            column: 3
          }
        }],
        line: 91
      },
      "5": {
        loc: {
          start: {
            line: 94,
            column: 15
          },
          end: {
            line: 94,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 15
          },
          end: {
            line: 94,
            column: 45
          }
        }, {
          start: {
            line: 94,
            column: 49
          },
          end: {
            line: 94,
            column: 71
          }
        }, {
          start: {
            line: 94,
            column: 75
          },
          end: {
            line: 94,
            column: 81
          }
        }],
        line: 94
      },
      "6": {
        loc: {
          start: {
            line: 97,
            column: 17
          },
          end: {
            line: 97,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 97,
            column: 17
          },
          end: {
            line: 97,
            column: 47
          }
        }, {
          start: {
            line: 97,
            column: 51
          },
          end: {
            line: 97,
            column: 73
          }
        }, {
          start: {
            line: 97,
            column: 77
          },
          end: {
            line: 97,
            column: 83
          }
        }],
        line: 97
      },
      "7": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 105,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 102,
            column: 14
          }
        }, {
          start: {
            line: 103,
            column: 4
          },
          end: {
            line: 105,
            column: 3
          }
        }],
        line: 102
      },
      "8": {
        loc: {
          start: {
            line: 117,
            column: 27
          },
          end: {
            line: 117,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 117,
            column: 42
          },
          end: {
            line: 117,
            column: 48
          }
        }, {
          start: {
            line: 117,
            column: 51
          },
          end: {
            line: 117,
            column: 59
          }
        }],
        line: 117
      },
      "9": {
        loc: {
          start: {
            line: 123,
            column: 20
          },
          end: {
            line: 123,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 20
          },
          end: {
            line: 123,
            column: 50
          }
        }, {
          start: {
            line: 123,
            column: 54
          },
          end: {
            line: 123,
            column: 79
          }
        }],
        line: 123
      },
      "10": {
        loc: {
          start: {
            line: 127,
            column: 22
          },
          end: {
            line: 127,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 22
          },
          end: {
            line: 127,
            column: 52
          }
        }, {
          start: {
            line: 127,
            column: 56
          },
          end: {
            line: 127,
            column: 81
          }
        }, {
          start: {
            line: 127,
            column: 85
          },
          end: {
            line: 127,
            column: 91
          }
        }],
        line: 127
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "cb6538639df061ebc62a679664fc9f55de543bd4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23f8484al5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_23f8484al5();
var _ref = (cov_23f8484al5().s[0]++, _stylingConstants.default),
  mediaQueries = _ref.mediaQueries;
var Wrapper = exports.Wrapper = (cov_23f8484al5().s[1]++, _styledComponents.default.header.attrs({
  className: 'stx-Header'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  box-sizing: border-box;\n  position: relative;\n  font-size: 13px;\n  // In order for mobile menu to overlap body content elements, z-index have to be higher than these elements\n  // Should match with the mobile menu z-index (gravity/MobileMenu)\n  z-index: 4;\n  background: ", ";\n  ", "\n  background-color: ", ";\n"])), function (props) {
  cov_23f8484al5().f[0]++;
  cov_23f8484al5().s[2]++;
  if (!props.showBgImagesOnMobile) {
    cov_23f8484al5().b[0][0]++;
    cov_23f8484al5().s[3]++;
    return 'none';
  } else {
    cov_23f8484al5().b[0][1]++;
  }
  cov_23f8484al5().s[4]++;
  return (cov_23f8484al5().b[1][0]++, props.theme.tsHeader.backgroundImage) || (cov_23f8484al5().b[1][1]++, '');
}, mediaQueries.tablet(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n    background: ", ";\n  "])), function (props) {
  cov_23f8484al5().f[1]++;
  cov_23f8484al5().s[5]++;
  return (cov_23f8484al5().b[2][0]++, props.theme.tsHeader.backgroundImage) || (cov_23f8484al5().b[2][1]++, '');
}), function (props) {
  cov_23f8484al5().f[2]++;
  cov_23f8484al5().s[6]++;
  return (cov_23f8484al5().b[3][0]++, props.theme.tsHeader.backgroundColor) || (cov_23f8484al5().b[3][1]++, 'transparent');
}));
var HeaderInner = exports.HeaderInner = (cov_23f8484al5().s[7]++, _styledComponents.default.div.attrs({
  className: 'stx-HeaderInner'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  max-width: 100%;\n  min-height: 3rem;\n  margin: 0 auto;\n  padding: 0.5em 2em;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  align-items: center;\n  background-color: 'black';\n  & svg {\n    vertical-align: middle;\n  }\n"]))));
var HeaderLeft = exports.HeaderLeft = (cov_23f8484al5().s[8]++, _styledComponents.default.div.attrs({
  className: 'stx-HeaderLeft'
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  width: 7rem;\n  max-width: 20rem;\n  ", "\n"])), mediaQueries.tablet(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["\n    margin: 5px 1em 5px 0;\n    width: 100%;\n  "])))));
var HeaderCenter = exports.HeaderCenter = (cov_23f8484al5().s[9]++, _styledComponents.default.div.attrs({
  className: 'stx-headerCenter'
})(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n"]))));
var HeaderRight = exports.HeaderRight = (cov_23f8484al5().s[10]++, _styledComponents.default.div.attrs({
  className: 'stx-HeaderRight'
})(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  ", "\n"])), mediaQueries.tablet(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n  "])))));
var HeaderItem = exports.HeaderItem = (cov_23f8484al5().s[11]++, _styledComponents.default.li.attrs({
  className: 'stx-HeaderItem'
})(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n  padding: 0.5rem;\n  &:last-of-type {\n    padding-left: 0;\n  }\n"]))));
var HeaderButton = exports.HeaderButton = (cov_23f8484al5().s[12]++, (0, _styledComponents.default)(_button.default).attrs({
  className: 'stx-HeaderButton'
})(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 14px;\n  white-space: nowrap;\n  ", ";\n  ", ";\n"])), function (props) {
  cov_23f8484al5().f[3]++;
  cov_23f8484al5().s[13]++;
  return (cov_23f8484al5().b[4][0]++, props.flat) && (cov_23f8484al5().b[4][1]++, "\n    & span {\n      color: ".concat((cov_23f8484al5().b[5][0]++, props.theme.tsHeader.textColor) || (cov_23f8484al5().b[5][1]++, props.theme.link.color) || (cov_23f8484al5().b[5][2]++, '#000'), ";\n      &:hover,\n      &:focus {\n        color: ").concat((cov_23f8484al5().b[6][0]++, props.theme.tsHeader.textColor) || (cov_23f8484al5().b[6][1]++, props.theme.link.color) || (cov_23f8484al5().b[6][2]++, '#000'), ";\n      }\n     }\n  "));
}, function (props) {
  cov_23f8484al5().f[4]++;
  cov_23f8484al5().s[14]++;
  return (cov_23f8484al5().b[7][0]++, props.bold) && (cov_23f8484al5().b[7][1]++, "\n    font-weight: 700;\n  ");
}));
var HeaderLink = exports.HeaderLink = (cov_23f8484al5().s[15]++, _styledComponents.default.a.attrs({
  className: 'stx-HeaderLink',
  tabIndex: 0
})(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  cursor: pointer;\n  transition: color 0.125s;\n  display: inline-block;\n  padding: 0;\n  font-weight: ", ";\n  text-decoration: none;\n  -webkit-font-smoothing: antialiased;\n  -webkit-touch-callout: none;\n  user-select: none;\n\n  color: ", ";\n\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), function (props) {
  cov_23f8484al5().f[5]++;
  cov_23f8484al5().s[16]++;
  return props.active ? (cov_23f8484al5().b[8][0]++, 'bold') : (cov_23f8484al5().b[8][1]++, 'normal');
}, function (props) {
  cov_23f8484al5().f[6]++;
  cov_23f8484al5().s[17]++;
  return (cov_23f8484al5().b[9][0]++, props.theme.tsHeader.textColor) || (cov_23f8484al5().b[9][1]++, props.theme.content.color);
}, function (props) {
  cov_23f8484al5().f[7]++;
  cov_23f8484al5().s[18]++;
  return (cov_23f8484al5().b[10][0]++, props.theme.tsHeader.textColor) || (cov_23f8484al5().b[10][1]++, props.theme.content.color) || (cov_23f8484al5().b[10][2]++, '#fff');
}));
var HeaderNav = exports.HeaderNav = (cov_23f8484al5().s[19]++, _styledComponents.default.nav.attrs({
  className: 'stx-HeaderNav'
})(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  height: 3rem;\n  align-items: center;\n"]))));
var HeaderList = exports.HeaderList = (cov_23f8484al5().s[20]++, _styledComponents.default.ul.attrs({
  className: 'stx-HeaderList'
})(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  height: 3rem;\n  align-items: center;\n  margin: 0px;\n"]))));
var HeaderToggle = exports.HeaderToggle = (cov_23f8484al5().s[21]++, _styledComponents.default.div(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 0.5rem;\n\n  ", "\n"])), mediaQueries.tablet(_templateObject15 || (_templateObject15 = (0, _taggedTemplateLiteral2.default)(["\n    display: none;\n  "])))));
var HeaderHideOnMobile = exports.HeaderHideOnMobile = (cov_23f8484al5().s[22]++, _styledComponents.default.div(_templateObject16 || (_templateObject16 = (0, _taggedTemplateLiteral2.default)(["\n  display: none;\n  align-items: center;\n  table-layout: fixed;\n  &.stx-HeaderNavContainer {\n    width: 100%;\n  }\n  ", "\n"])), mediaQueries.tablet(_templateObject17 || (_templateObject17 = (0, _taggedTemplateLiteral2.default)(["\n    display: flex;\n  "])))));
var HeaderHideOnDesktop = exports.HeaderHideOnDesktop = (cov_23f8484al5().s[23]++, _styledComponents.default.div(_templateObject18 || (_templateObject18 = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  align-items: center;\n\n  ", "\n"])), mediaQueries.tablet(_templateObject19 || (_templateObject19 = (0, _taggedTemplateLiteral2.default)(["\n    display: none;\n  "])))));